import { ComponentType } from 'react'
import ActivityPage from './ActivityPage'
import AssessmentPage from './AssessmentPage'
import AssessmentWebviewPage from './AssessmentWebviewPage'
import AuthPage from './AuthPage'
import BanPage from './BanPage'
import CallsPage from './CallsPage'
import DashboardPage from './DashboardPage'
import DevicesPage from './DevicesPage'
import GoogleAuthPage from './GoogleAuthPage'
import LeaderboardPage from './LeaderboardPage'
import LoginPage from './LoginPage'
import MissionDetailPage from './MissionDetailPage'
import MissionDetailWebviewPage from './MissionDetailWebviewPage'
import MissionsPage from './MissionsPage'
import MissionsWebviewPage from './MissionsWebviewPage'
import NectarTaskPage from './NectarTaskPage'
import NectarTaskWebviewPage from './NectarTaskWebviewPage'
import PayPalAuthPage from './PayPalAuthPage'
import ProfilePage from './ProfilePage'
import ProfileWebviewPage from './ProfileWebviewPage'
import { ProlificEntryPage } from './ProlificEntryPage'
import ProlificTaskPage from './ProlificTaskPage'
import ReferralsPage from './ReferralsPage'
import RestrictedDataPage from './RestrictedDataPage'
import StakeSOLPage from './StakeSOLPage'
import StripeReturnPage from './StripeReturnPage'
import WalletPage from './WalletPage'

/* const RestrictedDataPage = lazy(() => import('./RestrictedDataPage'))
const DashboardPage = lazy(() => import('./DashboardPage.tsx'))
const DevicesPage = lazy(() => import('./DevicesPage.tsx'))
const LoginPage = lazy(() => import('./LoginPage.tsx'))
const PolicyPage = lazy(() => import('./PolicyPage.tsx'))
const ReferralsPage = lazy(() => import('./ReferralsPage.tsx'))
const TermsPage = lazy(() => import('./TermsPage.tsx')) */

export type Route = {
  path: string
  Component: ComponentType
  isPublic?: boolean
  noMenu?: boolean
  isWebview?: boolean
  // Public (no auth) + full-page layout, no app chrome — used by the Prolific task runner.
  isProlific?: boolean
}

export const routes: Record<string, Route> = {
  login: { path: '/login', Component: LoginPage, isPublic: true },
  auth: { path: '/auth', Component: AuthPage, isPublic: true },
  googleAuth: { path: '/auth/google', Component: GoogleAuthPage, isPublic: true },
  // No `isPublic`: the PayPal consent callback requires auth — unauthenticated landings fall
  // into the existing login redirect (IV6).
  paypalAuth: { path: '/auth/paypal', Component: PayPalAuthPage },
  stripeReturn: { path: '/wallet/stripe/return', Component: StripeReturnPage },
  ban: { path: '/banned', Component: BanPage, isPublic: true },
  prolificEntry: { path: '/prolific', Component: ProlificEntryPage, isPublic: true },
  prolificTasks: {
    path: '/missions/prolific/:projectId/tasks',
    Component: ProlificTaskPage,
    isProlific: true
  },

  missions: { path: '/missions', Component: MissionsPage },
  mission: { path: '/missions/:id', Component: MissionDetailPage },
  nectarTasks: { path: '/missions/nectar/:projectId/tasks', Component: NectarTaskPage },
  assessment: { path: '/assessment/:langCode', Component: AssessmentPage },
  stake: { path: '/stake', Component: StakeSOLPage },

  dashboard: { path: '/dashboard', Component: DashboardPage },
  devices: { path: '/devices', Component: DevicesPage },
  referrals: { path: '/referrals', Component: ReferralsPage },
  leaderboard: { path: '/leaderboard', Component: LeaderboardPage },
  calls: { path: '/calls', Component: CallsPage },
  wallet: { path: '/wallet', Component: WalletPage },
  activity: { path: '/activity', Component: ActivityPage },
  authData: { path: '/restricted-data', Component: RestrictedDataPage },
  profile: { path: '/profile', Component: ProfilePage },

  profileWebview: { path: '/profile/webview', Component: ProfileWebviewPage, isWebview: true },
  missionsWebview: { path: '/missions/webview', Component: MissionsWebviewPage, isWebview: true },
  missionWebview: { path: '/missions/webview/:id', Component: MissionDetailWebviewPage, isWebview: true },
  nectarTasksWebview: {
    path: '/missions/webview/nectar/:projectId/tasks',
    Component: NectarTaskWebviewPage,
    isWebview: true
  },
  assessmentWebview: {
    path: '/assessment/webview/:langCode',
    Component: AssessmentWebviewPage,
    isWebview: true
  }
}

export type RouteKey = keyof typeof routes

export const nectarPaths = {
  tasks: (projectId: string, basePath: string = '/missions') => `${basePath}/nectar/${projectId}/tasks`
}
